import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import AnyLink from './anyLink';
import { useMobile } from '../../hooks/utilHooks';

const CustomTabs = ({
  tabs,
  handleTabSwitch,
  activeTabKey,
  activeTabIndex,
}) => {
  const isMobile = useMobile();
  const classes = useStyles();
  const [currentTabIndex, setCurrentTabIndex] = useState(activeTabIndex || 0);

  const getTabParams = (tab, index) => {
    return {
      dataUrl: tab.dataUrl,
      dataType: tab.type,
      communityDescription: tab.data,
      showFab: tab.showFab,
      tabIndex: index,
      tabKey: tab.tabKey || tab.key,
      categoryUrl: tab.categoryUrl,
      title: tab.title,
    };
  };

  //Set the activeTab field coming from server as the selected tab value for the Tabs component.

  useEffect(() => {
    activeTabIndex > -1 && setCurrentTabIndex(activeTabIndex);
  }, [activeTabIndex]);

  const tabProps = (index) => {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  };

  return (
    <Box className={classes.tabsScrollBar}>
      <Box width={1} className="container">
        <Tabs
          value={currentTabIndex}
          variant="scrollable"
          scrollButtons={isMobile ? 'off' : 'on'}
          indicatorColor="primary"
          aria-label="scrollable auto tabs example"
          className={classes.scrollIndicator}
        >
          {tabs &&
            tabs.map((tab, index) => (
              <Tab
                key={index}
                className={`${classes.tabTextBox} ${
                  tab.tabkey === activeTabKey
                    ? 'communityTabActive'
                    : classes.inactiveTab
                }`}
                label={
                  tab.categoryUrl ? (
                    <AnyLink to={tab.categoryUrl}>{tab.title}</AnyLink>
                  ) : (
                    tab.title
                  )
                }
                onClick={() =>
                  !tab.categoryUrl && handleTabSwitch(getTabParams(tab, index))
                }
                {...tabProps(index)}
              />
            ))}
        </Tabs>
      </Box>
    </Box>
  );
};
const useStyles = makeStyles((theme) => ({
  inactiveTab: {
    color: theme.palette.text.primary,
  },
  tabTextBox: {
    fontSize: '14px',
    margin: 'auto',
  },
  tabsScrollBar: {
    display: 'flex',
    alignItems: 'center',
    top: '50px!important',
    width: '100%',
    left: theme.spacing(0),
  },
  scrollIndicator: {
    color: theme.palette.text.primary,
    minHeight: '37px',
  },
}));
export default CustomTabs;
